import { LanguageEnum } from '../entities/language.enum';
import { LocaleSegmentResolution, resolveLocaleSegment } from '../entities/locale-url-segment';

export interface UrlOnlyLocaleTarget {
    language: LanguageEnum;
    /** Path canonico (sin query/hash, con "/" inicial) al que se redirige; null si la URL ya es canonica. */
    redirectPath: string | null;
    /** Prefijo inexistente (`/fr`, `/pt-BR`, `/ar-en`): la URL no existe. */
    notFound: boolean;
}

/**
 * Regla unica de rutas UrlOnly (/t y /u), compartida por cliente y server: solo es/en sin
 * regionalizacion, sin distinguir mayusculas (ver resolveLocaleSegment). Sin prefijo = espanol.
 * `/es`, `/es-XX` y un pais (`/co`, `/es-CO`) => ruta sin prefijo; `/en-XX` y `/EN` => `/en/...`;
 * `/en` ya canonico no redirige. Idiomas inexistentes y paises con sufijo => notFound.
 */
export function resolveUrlOnlyLocaleTarget(segments: ReadonlyArray<string>): UrlOnlyLocaleTarget {
    const first: string = segments[0] ?? '';
    const resolution: LocaleSegmentResolution = resolveLocaleSegment(first);
    const rest: string = segments.slice(1).join('/');

    switch (resolution.kind) {
        case 'en':
            return {
                language: LanguageEnum.EN,
                redirectPath: first === LanguageEnum.EN ? null : `/${LanguageEnum.EN}/${rest}`,
                notFound: false,
            };
        case 'es':
        case 'country':
            return { language: LanguageEnum.ES, redirectPath: `/${rest}`, notFound: false };
        case 'invalid':
            return { language: LanguageEnum.ES, redirectPath: null, notFound: true };
        default:
            return { language: LanguageEnum.ES, redirectPath: null, notFound: false };
    }
}
